<template>
  <div class="scheduling-content">
    <div class="s-filter-box">
      <div class="b-left">
        <span class="title">
          {{ 'Production Schedule -' + route.query.name }}
        </span>
      </div>
      <div class="btn-right">
        <a-button type="link" @click="openOvertimePopup">Overtime</a-button>
        <a-divider type="vertical" />
        <a-button type="link" @click="goSchedulingOrsimulation">
          <span v-if="isSimulation">Scheduling</span>
          <span v-else>Simulation</span>
        </a-button>
        <a-divider type="vertical" />
        <a-button type="link" @click="helpModalVis = true">Legend</a-button>
        <a-divider type="vertical" />
        <a-button type="link" :disabled="!getData.length" @click="doload()">
          Export
        </a-button>
        <a-divider type="vertical" />
        <a-button type="link" @click="reload()">Refresh</a-button>
      </div>
    </div>
    <CardList
      ref="cardRef"
      :data-list="getData"
      :is-select-sort="true"
      page-name="simulation"
      :save-text="saveText"
      :net-group="netGroup"
      :sort-name="searchColumnBy"
      @dataUpdate="updateGetData"
      @onReqEndChange="reqEndChange"
      @onCancelLeveling="onCancel"
      @onSave="saveFn"
    ></CardList>
    <!-- 帮助信息 -->
    <LegendModal
      :isOpen="helpModalVis"
      @onModalClose="helpModalVis = false"
    ></LegendModal>
    <!-- workstion overtime -->
    <OverTime
      :isOpen="overTimeModalVis"
      @onModalClose="overTimeModalVis = false"
    ></OverTime>
  </div>
</template>

<script setup>
  import request from '@/utils/request'
  import { ref, computed } from 'vue'
  import Storage from 'good-storage'
  import { useStore } from 'vuex'
  import { message } from 'ant-design-vue'
  import OverTime from './components/over-time-modal.vue'
  import dayjs from 'dayjs'
  import { baseURL } from '@/config'
  import LegendModal from './components/legend-modal.vue'
  import CardList from './components/card-list.vue'
  import { useRouter, useRoute } from 'vue-router'
  const store = useStore()
  const router = useRouter()
  const route = useRoute()

  const netGroup = computed(() => store.getters['user/currentNetGroup'])
  const currentSystem = computed(() => store.getters['user/currentSystem'])
  const isSimulation = computed(() => route.query.name === 'simulation')
  const searchColumnBy = 'reqEnd'

  const cardRef = ref(null)

  // 下载
  const doload = () => {
    const status = isSimulation.value
      ? 'leveled,releveled'
      : 'leveled,releveled,planned'
    let url = `${baseURL}/api/schedule/downloadOrderMain?current-system=${currentSystem.value}&netGroupId=${netGroup.value}&status=${status}`
    window.location.href = url
  }
  const goSchedulingOrsimulation = () => {
    router.push(
      `/scheduling/scheduling-schedulingIndex?name=${
        isSimulation.value ? 'scheduling' : 'simulation'
      }`
    )
  }
  const reload = function () {
    ssInit()
    Storage.remove('simulation')
  }
  const updateGetData = (list) => {
    getData.value = getData.value.map((item) => {
      const f = list.find((m) => m.id === item.id)
      if (f) {
        item = f
      }
      return item
    })
  }
  const overTimeModalVis = ref(false)
  const openOvertimePopup = () => {
    overTimeModalVis.value = true
  }
  // 图例
  const helpModalVis = ref(false)

  // start 主体内容================================================
  const saveText = isSimulation.value ? 'Save simulation' : 'Save scheduling'
  const getData = ref([])
  const requestTime = ref(0)
  const ssInit = async (url = '/api/scheduling/initial') => {
    const hide = message.loading('Loading……', 0)

    try {
      const { body, errCode, errMsg } = await request({
        url,
        nonstandard: true,
        params: {
          netGroupId: netGroup.value,
        },
      })
      if (errCode === '0000') {
        getData.value = body.data
        requestTime.value = body.loadTime
        Storage.set('simulationLoadTime', body.loadTime)
      } else {
        getData.value = []
        message.error(errMsg)
      }
      hide()
    } catch (e) {
      hide()
      getData.value = []
    }
  }
  ssInit()

  // reqEnd修改
  const reqEndChange = (pList) => {
    const hide = message.loading('Submitting', 0)
    const list = []
    pList.forEach((item) => {
      if (item.workOrders.length) {
        item.workOrders.forEach((m) => {
          list.push({
            id: m.id,
            reqEnd: dayjs(m.reqEnd2).valueOf(),
          })
        })
      }
    })
    request({
      url: '/api/scheduling/changeReqDate',
      method: 'post',
      data: {
        netGroupId: netGroup.value,
        loadTime: requestTime.value || 0,
        data: list || null,
      },
    })
      .then((res) => {
        getData.value = res.body.data
        requestTime.value = res.body.loadTime
      })
      .finally(() => {
        hide()
      })
  }
  const saveFn = (list) => {
    const hide = message.loading('Saving', 0)
    const reqList = list.map((item) => {
      return { id: item.id, reqEnd: item.reqEnd }
    })
    if (isSimulation.value) {
      request({
        url: '/api/scheduling/simulate',
        method: 'post',
        nonstandard: true,
        data: {
          netGroupId: netGroup.value,
          loadTime: requestTime.value || 0,
          data: reqList || null,
        },
      })
        .then((res) => {
          if (res.errCode === '0000') {
            getData.value = res.body.data
            requestTime.value = res.body.loadTime
            Storage.set('simulation', res.body)
            message.success('Save Success!')
          } else {
            if (res.errCode == '1012' || res.errCode == '1019') {
              message.warning(res.errMsg).then(() => {
                ssInit()
              })
            } else {
              message.error(res.errMsg || '未知错误')
            }
          }
        })
        .finally(() => {
          hide()
        })
    } else {
      request({
        url: '/api/scheduling/execute',
        method: 'post',
        nonstandard: true,
        data: {
          netGroupId: netGroup.value,
          loadTime: requestTime.value || 0,
          data: reqList || null,
        },
      })
        .then((res) => {
          if (res.errCode === '0000') {
            getData.value = []
            Storage.remove('simulation')
            message.success('Save Success!')
          } else {
            if (res.errCode == '1012' || res.errCode == '1019') {
              message.warning(res.errMsg).then(() => {
                ssInit()
              })
            } else {
              message.error(res.errMsg || '未知错误')
            }
          }
        })
        .finally(() => {
          hide()
        })
    }
  }
  const onCancel = () => {
    ssInit()
  }
  // end 主体内容=========================================================
</script>

<style lang="less" scoped>
  @import './less/scheduling.less';
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-weight: 600;
    }
  }
</style>
